import React from "react";
import {faArrowAltCircleLeft} from "@fortawesome/free-regular-svg-icons/faArrowAltCircleLeft";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useSWR from "swr";

import {ImageUpload} from "../../../components/image-upload/ImageUpload";
import { Button, Toast } from "../../../components";
import {InputField} from "../../../components/input-field/InputField";
import {AXIOS} from "../../../services/api";
import {Select} from "../../../components/select/Select";

import styles from "./AddUser.module.scss";

function AddUser({onSubmit, onClose}) {
    const [image, setImage] = React.useState(null);
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [role, setRole] = React.useState("");
    const [toastMessage, setToastMessage] = React.useState("");

    const {data, isLoading, error} = useSWR('roles', AXIOS.get);

    const roles = data?.data || [];

    async function handleSubmit(e) {
        e.preventDefault();

        if (!firstName || !lastName || !email || !role) {
            showToast('Please fill required fields');
            return;
        }

        const formData = new FormData();
        formData.append("image", image);
        formData.append("firstname", firstName);
        formData.append("lastname", lastName);
        formData.append("email", email);
        formData.append("role", role);

        try {
            const response = await AXIOS.post("/users", formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            if (response.status === 201) {
                onSubmit(response?.data?.data);
            } else {
                setToastMessage("User creation failed");
                setTimeout(() => setToastMessage(""), 2000);
            }
        } catch (error) {
            showToast(error?.message || 'An error occurred');
            onClose();
        }
    }

    function showToast(message) {
        setToastMessage(message);
        setTimeout(() => setToastMessage(""), 2000);
    }

    return (
        <div className={styles.modalContent}>
            <form className={styles.userForm} onSubmit={handleSubmit}>
                <div className={styles.userFormHeader}>
                    <h2>Add New User</h2>
                    <p>Fill in the details to create a new user account</p>
                </div>

                <div className={styles.userFormFields}>
                    <div className={styles.userFormFieldGroup}>
                        <div className={styles.userFormField}>
                            <label htmlFor="firstname">First Name</label>
                            <InputField
                                type="text"
                                id="firstname"
                                className={styles.userFormInput}
                                value={firstName}
                                placeholder="Enter first name"
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>

                        <div className={styles.userFormField}>
                            <label htmlFor="lastname">Last Name</label>
                            <InputField
                                type="text"
                                id="lastname"
                                className={styles.userFormInput}
                                value={lastName}
                                placeholder="Enter last name"
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={styles.userFormField}>
                        <label htmlFor="email">Email</label>
                        <InputField
                            type="email"
                            id="email"
                            className={styles.userFormInput}
                            value={email}
                            placeholder="Enter email address"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className={styles.userFormField}>
                        <label htmlFor="role">Role</label>
                        <Select
                            id="role"
                            className={styles.userFormInput}
                            options={roles}
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            placeholder="Select user role"
                        />
                    </div>

                    <div className={`${styles.userFormField} ${styles.imageUploadField}`}>
                        <label>Profile Picture</label>
                        <div className={styles.imageUploadContainer}>
                            <ImageUpload onImageChange={setImage} />
                        </div>
                    </div>
                </div>

                <div className={styles.userFormActions}>
                    <Button
                        label="Cancel"
                        variant="secondary"
                        onClick={onClose}
                    />
                    <Button
                        label="Create User"
                        variant="primary"
                        type="submit"
                    />
                </div>
            </form>

            {toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage("")} />}
        </div>
    );
}

export {AddUser};
